import { Card, PulseCTA } from "../funnel";

const PILLARS = [
  ["01", "Real-world experience", "Practical knowledge from navigating credit, banking, and business funding."],
  ["02", "Built through adversity", "From foster care and homelessness to building a stronger financial future."],
  ["03", "Knowledge you can use", "Learn how credit profiles, lender requirements, and funding strategies work."],
  ["04", "Skills that create opportunity", "Discover how credit and funding knowledge can become a valuable professional skill."],
];

export const MentorExtras = () => (
  <>
    <figure className="relative mt-20 overflow-hidden rounded-2xl border border-[var(--gold)] bg-[linear-gradient(180deg,#1d1810,#0b0a08)] px-6 py-14 text-center shadow-[0_0_60px_-10px_rgba(232,184,74,0.35)] sm:px-12 sm:py-20" data-testid="mentor-quote-panel">
      <div className="breathe-glow pointer-events-none absolute inset-0" aria-hidden="true" />
      <blockquote className="relative font-display gold-text text-4xl uppercase leading-[0.95] sm:text-6xl lg:text-7xl">
        THE SCORE GETS YOU NOTICED. THE PROFILE GETS YOU FUNDED.
      </blockquote>
      <figcaption className="font-serif-it relative mt-6 text-xl text-[#efe6d1]">— Jay Shelton</figcaption>
    </figure>

    <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {PILLARS.map(([n, title, body]) => (
        <Card key={n} hover className="flex h-full flex-col p-7" data-testid={`mentor-pillar-${n}`}>
          <p className="font-mono-plex text-sm tracking-[0.2em] text-[var(--gold)]">{n}</p>
          <h3 className="mt-4 text-lg font-semibold leading-snug text-[#f4efe4]">{title}</h3>
          <p className="mt-2 text-[15px] leading-relaxed text-[#b9b1a2]">{body}</p>
        </Card>
      ))}
    </div>

    <div className="mx-auto mt-20 flex max-w-3xl flex-col items-center text-center" data-testid="mentor-closing">
      <h3 className="gold-text text-3xl font-semibold leading-tight sm:text-4xl">Your next chapter starts with what you learn today.</h3>
      <p className="mt-6 text-[16px] leading-relaxed text-[#cfc7b6]">You don't need to have everything figured out. You don't need to be a credit expert. And you don't need to already own a business. You just need to be willing to learn.</p>
      <p className="mt-4 text-[16px] leading-relaxed text-[#cfc7b6]">Join me for my FREE Weaponize Credit to Capital webinar, where I'll introduce you to the principles of building a stronger credit profile, understanding business funding, and developing valuable skills in the credit and funding industry.</p>
      <PulseCTA className="mt-9 w-full sm:w-auto" data-testid="mentor-cta-button">SAVE MY SEAT →</PulseCTA>
      <p className="font-mono-plex mt-6 text-[10.5px] leading-relaxed tracking-[0.18em] text-[#a59f93] sm:text-[11px]">FREE WEBINAR | LEARN CREDIT. UNDERSTAND FUNDING. DISCOVER NEW OPPORTUNITIES.</p>
    </div>
  </>
);
